module.exports = __webpack_public_path__ + "static/media/ph-meter.e232125a.svg";